import React, { ReactNode, useMemo } from "react";

import { Spinner, Text } from "@performyard/py-components";

export const CompensationInfoWidget = ({
	title,
	counter,
	description,
	isLoading = false,
	testId = "widget",
}: {
	title: ReactNode;
	counter: number;
	description: string[];
	isLoading?: boolean;
	testId?: string;
}) => {
	const counterDisplay = useMemo(() => {
		const suffixes = ["", "K", "M", "B"];
		let valueCounter = counter;
		let suffixIndex = 0;
		while (valueCounter >= 1000) {
			valueCounter /= 1000;
			suffixIndex++;
		}
		let counterValue = valueCounter.toFixed(2);
		let counterAbbreviation = suffixes[suffixIndex];

		if (counterAbbreviation === undefined) {
			counterValue = counter.toExponential(0);
			counterAbbreviation = "";
		}

		return `${counterValue}${counterAbbreviation}`;
	}, [counter]);

	return (
		<div
			data-testid={testId}
			className="flex max-h-[112px] flex-1 flex-col rounded-md border border-solid border-neutral-2 p-4"
		>
			<div className="flex gap-1">
				<Text size="paragraph-3" weight="regular" color="neutral-5">
					{title}
				</Text>
			</div>
			{isLoading ? (
				<div className="flex h-[48px] w-full items-center justify-around">
					<Spinner size={32} />
					<span />
					<span />
				</div>
			) : (
				<>
					<Text size="heading-2" weight="semi-bold">
						${counterDisplay}
					</Text>
					<Text size="caption" weight="regular" color="neutral-5">
						{description.join(" ")}
					</Text>
				</>
			)}
		</div>
	);
};
